module.exports = __webpack_public_path__ + "static/media/blockchain.54ba73b3.svg";